var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.33333L10.8993 12.6767C10.8468 13.495 10.8204 13.9042 10.65 14.2144C10.4999 14.4876 10.2736 14.7072 10.0008 14.8443C9.691 15 9.29552 15 8.50465 15H5.49533C4.70445 15 4.30901 15 3.99917 14.8443C3.72638 14.7072 3.50004 14.4876 3.34999 14.2144C3.17955 13.9042 3.15325 13.495 3.10064 12.6767L2.5 3.33333M1 3.33333H13M10 3.33333L9.79705 2.70183C9.60032 2.08986 9.50193 1.78388 9.31953 1.55765C9.15843 1.35788 8.95157 1.20325 8.71787 1.10794C8.4532 1 8.14225 1 7.5202 1H6.4798C5.85775 1 5.5468 1 5.28213 1.10794C5.04844 1.20325 4.84156 1.35788 4.68047 1.55765C4.49804 1.78388 4.39969 2.08986 4.20298 2.70183L4 3.33333M8.5 6.44444V11.8889M5.5 6.44444V11.8889",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/Bucket.41732751ad0d7be745629eb3b7e81225.svg";
export { ForwardRef as ReactComponent };